import React, { useState, useEffect, useRef } from 'react';
import {
  Box,
  Typography,
  IconButton,
  Avatar,
  Chip,
  Grid,
  TextField,
  Tabs,
  Tab,
  InputAdornment,
  Button,
  Divider,
} from '@mui/material';
import {
  Edit,
  Close,
  Badge as BadgeIcon,
  CalendarMonth,
  CheckCircle,
  Email,
  LocationOn,
  Phone,
  HomeWork,
  Business,
  ExitToApp,
  School,
  Person,
  CorporateFare,
  Groups,
  CalendarToday,
  Cake,
  Transgender,
  Fingerprint,
  LocalHospital,
  ContactEmergency,
  AccountCircle,
  Work,
  BusinessCenter,
} from '@mui/icons-material';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import {axiosInstance, localAxiosGet, localAxiosPut } from '../Axios/axios';

const EditProfile = ({ onClose }) => {
  const [empId, setEmpId] = useState(null);
  const [empOrgId, setEmpOrgId] = useState(null);
  const [empDetails, setEmpDetails] = useState(null);
  const [profileTabValue, setProfileTabValue] = useState(0);
  const [editMode, setEditMode] = useState({
    personal: false,
    contact: false,
    work: false
  });
  const [userData, setUserData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [profileImage, setProfileImage] = useState(null); 
  const fileInputRef = useRef(null); 

  const [originalFields, setOriginalFields] = useState({
    // Personal Details
    first_name: '',
    last_name: '',
    date_of_birth: '',
    gender: '',
    blood_group: '',
    aadhar_number: '',
    
    // Contact Details
    address: '',
    phone_number: '',
    personal_email: '',
    emergency_contact: '',
    emergency_contact_relationship: '',
    
    // Work Details
    employee_id: '',
    work_location: '',
    // work_phone: '',
  });

  const [updatedFields, setUpdatedFields] = useState({
    // Personal Details
    first_name: '',
    last_name: '',
    date_of_birth: '',
    gender: '',
    blood_group: '',
    aadhar_number: '',
    
    // Contact Details
    address: '',
    phone_number: '',
    personal_email: '',
    emergency_contact: '',
    emergency_contact_relationship: '',
    
    // Work Details
    employee_id: '',
    work_location: '',
    // work_phone: '',
  });

  const [isSubmitting, setIsSubmitting] = useState(false);
  const [updateSuccess, setUpdateSuccess] = useState(false);
  const [openTokenExpirePopup, setOpenTokenExpirePopup] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    const employeid = localStorage.getItem("userId");
    const employeorgid = localStorage.getItem("organizationId");
    const employeDetails = localStorage.getItem("userDetails");
    const accessToken = localStorage.getItem("accessToken");

    if (employeid) {
      setEmpId(employeid);

      const fetchUserDetails = async () => {
        try {
          setLoading(true);
          const response = await axiosInstance(localAxiosGet(`/organization/getUserDetailsByUserId?userId=${employeid}`, accessToken));

          if (response.data && response.data.statusCode === 200 && response.data.message && response.data.message.user) {
            const user = response.data.message.user;
            setUserData(user);

            // Set all fields from API
            const initialFields = {
              // Personal Details
              first_name: user.first_name || '',
              last_name: user.last_name || '',
              date_of_birth: user.date_of_birth || '',
              gender: user.gender || '',
              blood_group: user.blood_group || '',
              aadhar_number: user.aadhar_number || '',
              
              // Contact Details
              address: user.address || '',
              phone_number: user.phone_number || '',
              personal_email: user.personal_email || '',
              emergency_contact: user.emergency_contact || '',
              emergency_contact_relationship: user.emergency_contact_relationship || '',
              
              // Work Details
              employee_id: user.employee_id || '',
              work_location: user.work_location || user.location_name || '',
              // work_phone: user.work_phone || '',
            };

            setOriginalFields(initialFields);
            setUpdatedFields(initialFields);

            console.log("User data from API:", user);
          }
        } catch (error) {
          console.error("Error fetching user details:", error);
          tryUseLocalStorageData();
        } finally {
          setLoading(false);
        }
      };

      fetchUserDetails();
    }

    if (employeorgid) {
      setEmpOrgId(employeorgid);
    }

    function tryUseLocalStorageData() {
      const employeDetails = localStorage.getItem("userDetails");
      if (employeDetails) {
        try {
          const parsedDetails = JSON.parse(employeDetails);
          setEmpDetails(parsedDetails);

          const initialFields = {
            // Personal Details
            first_name: parsedDetails.first_name || '',
            last_name: parsedDetails.last_name || '',
            date_of_birth: parsedDetails.date_of_birth || '',
            gender: parsedDetails.gender || '',
            blood_group: parsedDetails.blood_group || '',
            aadhar_number: parsedDetails.aadhar_number || '',
            
            // Contact Details
            address: parsedDetails.address || '',
            phone_number: parsedDetails.phone_number || '',
            personal_email: parsedDetails.personal_email || '',
            emergency_contact: parsedDetails.emergency_contact || '',
            emergency_contact_relationship: parsedDetails.emergency_contact_relationship || '',
            
            // Work Details
            employee_id: parsedDetails.employee_id || '',
            work_location: parsedDetails.work_location || parsedDetails.location_name || '',
            // work_phone: parsedDetails.work_phone || '',
          };

          setOriginalFields(initialFields);
          setUpdatedFields(initialFields);
        } catch (error) {
          console.error("Error parsing employee details:", error);
        }
      }
    }

    if (employeDetails) {
      try {
        const parsedDetails = JSON.parse(employeDetails);
        setEmpDetails(parsedDetails);

        if (!userData) {
          const initialFields = {
            // Personal Details
            first_name: parsedDetails.first_name || '',
            last_name: parsedDetails.last_name || '',
            date_of_birth: parsedDetails.date_of_birth || '',
            gender: parsedDetails.gender || '',
            blood_group: parsedDetails.blood_group || '',
            aadhar_number: parsedDetails.aadhar_number || '',
            
            // Contact Details
            address: parsedDetails.address || '',
            phone_number: parsedDetails.phone_number || '',
            personal_email: parsedDetails.personal_email || '',
            emergency_contact: parsedDetails.emergency_contact || '',
            emergency_contact_relationship: parsedDetails.emergency_contact_relationship || '',
            
            // Work Details
            employee_id: parsedDetails.employee_id || '',
            work_location: parsedDetails.work_location || parsedDetails.location_name || '',
            // work_phone: parsedDetails.work_phone || '',
          };

          setOriginalFields(prevState => ({
            ...prevState,
            ...initialFields
          }));

          setUpdatedFields(prevState => ({
            ...prevState,
            ...initialFields
          }));
        }
      } catch (error) {
        console.error("Error parsing employee details:", error);
      }
    }
  }, []);

  const handleTabChange = (event, newValue) => {
    setProfileTabValue(newValue);
  };

  const getCurrentTabKey = () => {
    const tabs = ['personal', 'contact', 'work'];
    return tabs[profileTabValue];
  };

  const isCurrentTabEditable = () => {
    return editMode[getCurrentTabKey()];
  };

  const handleEditToggle = () => {
    const currentTab = getCurrentTabKey();
    
    if (editMode[currentTab]) {
      // Cancel edit - reset fields for current tab
      const tabFields = getTabFields(currentTab);
      const resetFields = { ...updatedFields };
      tabFields.forEach(field => {
        resetFields[field] = originalFields[field];
      });
      setUpdatedFields(resetFields);
    }
    
    setEditMode(prev => ({
      ...prev,
      [currentTab]: !prev[currentTab]
    }));
    setUpdateSuccess(false);
  };

  const getTabFields = (tabKey) => {
    const fieldMap = {
      personal: ['first_name', 'last_name', 'date_of_birth', 'gender', 'blood_group', 'aadhar_number'],
      contact: ['address', 'phone_number', 'personal_email', 'emergency_contact', 'emergency_contact_relationship'],
      work: ['employee_id', 'work_location', ]
    };
    return fieldMap[tabKey] || [];
  };

  const handleInputChange = (field, value) => {
    setUpdatedFields(prev => ({
      ...prev,
      [field]: value
    }));
  };

  const handleSaveChanges = async () => {
    const userId = localStorage.getItem('userId');
    const accessToken = localStorage.getItem("accessToken");
    const currentTab = getCurrentTabKey();

    if (!userId) {
      console.error("User ID not found");
      return;
    }

    try {
      setIsSubmitting(true);

      // Only include fields from the current tab in the payload
      const tabFields = getTabFields(currentTab);
      const payload = {
        user_pic: profileImage
      };

      tabFields.forEach(field => {
        payload[field] = updatedFields[field];
      });

      const response = await axiosInstance(localAxiosPut(
        `/organization/updateEmployeeDetails?userId=${userId}`,
        payload, accessToken
      ));

      if (response.data && response.data.statusCode === 200) {
        console.log("Profile updated successfully:", response.data);

        const updatedUser = response.data.message.updatedUser;
        setUserData(updatedUser);

        const newFields = {
          // Personal Details
          first_name: updatedUser.first_name,
          last_name: updatedUser.last_name,
          date_of_birth: updatedUser.date_of_birth,
          gender: updatedUser.gender,
          blood_group: updatedUser.blood_group,
          aadhar_number: updatedUser.aadhar_number,
          
          // Contact Details
          address: updatedUser.address,
          phone_number: updatedUser.phone_number,
          personal_email: updatedUser.personal_email,
          emergency_contact: updatedUser.emergency_contact,
          emergency_contact_relationship: updatedUser.emergency_contact_relationship,
          
          // Work Details
          employee_id: updatedUser.employee_id,
          work_location: updatedUser.work_location,
          // work_phone: updatedUser.work_phone,
        };

        setOriginalFields(newFields);
        setUpdatedFields(newFields);

        if (empDetails) {
          const updatedDetails = {
            ...empDetails,
            ...updatedUser
          };
          localStorage.setItem("userDetails", JSON.stringify(updatedDetails));
          setEmpDetails(updatedDetails);
        }

        setUpdateSuccess(true);
        setEditMode(prev => ({
          ...prev,
          [currentTab]: false
        }));
      } else {
        console.error("Failed to update profile:", response.data);
      }
    } catch (error) {
      console.error("Error updating profile:", error);
      if (error.response && error.response.status === 403) {
        setOpenTokenExpirePopup(true);
      }
    } finally {
      setIsSubmitting(false);
    }
  };

  // const handleCloseTokenExpirePopup = () => {
  //   setOpenTokenExpirePopup(false);
  //   navigate('/'); 
  // };

  const handleCancel = () => {
    const currentTab = getCurrentTabKey();
    const tabFields = getTabFields(currentTab);
    const resetFields = { ...updatedFields };
    
    tabFields.forEach(field => {
      resetFields[field] = originalFields[field];
    });
    
    setUpdatedFields(resetFields);
    setEditMode(prev => ({
      ...prev,
      [currentTab]: false
    }));
    setUpdateSuccess(false);
  };

  const handleSignOutButton = () => {
    localStorage.removeItem("userId");
    localStorage.removeItem("organizationId");
    localStorage.removeItem("userDetails");
    localStorage.removeItem("accessToken");
    localStorage.removeItem("refreshToken");
    localStorage.removeItem("userIpAddress");
    localStorage.removeItem("userType");
    localStorage.removeItem("reportingmanagerId");
    localStorage.removeItem("locationId");
    localStorage.removeItem('isSubscribed');

    axiosInstance.post('/organization/logout').catch(err => {
      console.error("Error during logout API call:", err);
    });
    
    navigate('/');
  };

  const capitalizeFirstChar = (str) => {
    if (!str) return "";
    return str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();
  };

  const formatDate = (dateString) => {
    if (!dateString) return '';
    try {
      return new Date(dateString).toLocaleDateString('en-GB');
    } catch {
      return dateString;
    }
  };

  // Get display values
  const firstName = capitalizeFirstChar(userData?.first_name || empDetails?.first_name || '');
  const lastName = capitalizeFirstChar(userData?.last_name || empDetails?.last_name || '');
  const displayName = firstName && lastName ? `${firstName} ${lastName}` : 'Employee Name';
  
  const email = userData?.email || empDetails?.email || '';
  const userType = userData?.user_type || empDetails?.user_type || '';
  const designation = userData?.designation || empDetails?.designation || '';
  const joinDate = userData?.doj || empDetails?.doj || '';
  const formattedJoinDate = formatDate(joinDate);
  const userStatus = userData?.status || empDetails?.status || '';
  const department = userData?.department || empDetails?.department || '';
  const team = userData?.team || empDetails?.team || '';
  const location = userData?.location_name || empDetails?.location_name || '';
  const organizationName = userData?.organization_name || empDetails?.organization_name || '';
  
  const managerFirstName = userData?.report_manager_first_name || empDetails?.report_manager_first_name || '';
  const managerLastName = userData?.report_manager_last_name || empDetails?.report_manager_last_name || '';
  const managerName = (managerFirstName || managerLastName) ? 
    `${capitalizeFirstChar(managerFirstName)} ${capitalizeFirstChar(managerLastName)}` : 
    'Not Assigned';
  const managerEmail = userData?.report_manager_email || empDetails?.report_manager_email || '';

  // Use employee_id instead of user_id
  const displayEmployeeId = userData?.emp_id || empDetails?.emp_id || empId || '';

  const getInitials = () => {
    const firstInitial = firstName ? firstName.charAt(0).toUpperCase() : '';
    const lastInitial = lastName ? lastName.charAt(0).toUpperCase() : '';
    return firstInitial + lastInitial;
  };

  const handleProfilePicChange = (event) => {
    const file = event.target.files[0];
    if (file) {
      const reader = new FileReader();
      reader.onload = () => {
        setProfileImage(reader.result);
      };
      reader.readAsDataURL(file);
    }
  };

  const handleEditProfilePicClick = () => {
    fileInputRef.current.click();
  };

  const renderEditableField = (label, field, value, icon, type = 'text', multiline = false) => {
    const isEditable = isCurrentTabEditable();
    
    return (
      <Grid item xs={12} sm={6}>
        <Typography variant="subtitle2" fontWeight="bold" gutterBottom sx={{ display: 'flex', alignItems: 'center' }}>
          {icon}
          {label}
        </Typography>
        {isEditable ? (
          <TextField
            fullWidth
            variant="outlined"
            size="small"
            type={type}
            multiline={multiline}
            rows={multiline ? 2 : 1}
            value={value}
            placeholder={`Enter your ${label.toLowerCase()}`}
            onChange={(e) => handleInputChange(field, e.target.value)}
          />
        ) : (
          <Typography variant="body2" sx={{ ml: 3 }}>
            {value || 'Not specified'}
          </Typography>
        )}
      </Grid>
    );
  };

  const renderNonEditableField = (label, value, icon) => {
    return (
      <Grid item xs={12} sm={6}>
        <Typography variant="subtitle2" fontWeight="bold" gutterBottom sx={{ display: 'flex', alignItems: 'center' }}>
          {icon}
          {label}
        </Typography>
        <Typography variant="body2" sx={{ ml: 3 }}>
          {value || 'Not specified'}
        </Typography>
      </Grid>
    );
  };

  return (
    <div>
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          p: 2,
          background: 'linear-gradient(135deg, #34495E 0%, #2C3E50 100%)',
          color: 'white'
        }}
      >
        <Typography variant="h6" fontWeight="bold">
          Profile Details
        </Typography>
        <Box>
          <IconButton
            onClick={handleEditToggle}
            sx={{ color: 'white', mr: 1 }}
          >
            {isCurrentTabEditable() ? <Close /> : <Edit />}
          </IconButton>
          <IconButton
            onClick={onClose}
            sx={{ color: 'white' }}
          >
            <Close />
          </IconButton>
        </Box>
      </Box>

      <Box sx={{ p: 0 }}>
        <Box
          sx={{
            display: 'flex',
            flexDirection: { xs: 'column', sm: 'row' },
            alignItems: { xs: 'center', sm: 'flex-start' },
            p: 3,
            pb: 4,
            background: 'linear-gradient(to right, rgba(41, 128, 185, 0.1), rgba(52, 152, 219, 0.05))',
            position: 'relative'
          }}
        >
          <Box sx={{ position: 'relative', mb: { xs: 2, sm: 0 }, mr: { xs: 0, sm: 3 } }}>
            <Avatar
              sx={{
                width: 100,
                height: 100,
                bgcolor: '#34495E',
                color: 'white',
                fontWeight: 'bold',
                fontSize: '2rem',
                border: '4px solid #ECF0F1'
              }}
              src={profileImage}
            >
              {!profileImage && getInitials()}
            </Avatar>
            <IconButton
              size="small"
              sx={{
                position: 'absolute',
                bottom: 0,
                right: 0,
                bgcolor: '#3498DB',
                color: 'white',
                '&:hover': { bgcolor: '#2980B9' }
              }}
              onClick={handleEditProfilePicClick}
            >
              <Edit fontSize="small" />
            </IconButton>

            <input
              type="file"
              accept="image/*"
              ref={fileInputRef}
              onChange={handleProfilePicChange}
              style={{ display: 'none' }}
            />
          </Box>

          <Box sx={{ flex: 1 }}>
            <Box sx={{ display: 'flex', flexDirection: 'column' }}>
              <Typography variant="h5" fontWeight="bold" gutterBottom>
                {displayName}
              </Typography>

              <Typography variant="subtitle1" color="text.secondary" gutterBottom>
                {designation ? `${userType} - ${designation}` : userType}
              </Typography>

              <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mt: 1, flexWrap: 'wrap' }}>
                <Chip
                  icon={<BadgeIcon fontSize="small" />}
                  label={`EMP ID: ${displayEmployeeId}`}
                  size="small"
                  sx={{ bgcolor: '#f0f0f0' }}
                />
                {formattedJoinDate && (
                  <Chip
                    icon={<CalendarMonth fontSize="small" />}
                    label={`DOJ: ${formattedJoinDate}`}
                    size="small"
                    sx={{ bgcolor: '#f0f0f0' }}
                  />
                )}
                {userStatus && (
                  <Chip
                    icon={<CheckCircle fontSize="small" />}
                    label={capitalizeFirstChar(userStatus)}
                    size="small"
                    color="success"
                    sx={{ color: 'white' }}
                  />
                )}
              </Box>
            </Box>
          </Box>

          <Box sx={{
            position: { xs: 'relative', sm: 'absolute' },
            top: { xs: 'auto', sm: 16 },
            right: { xs: 'auto', sm: 16 },
            mt: { xs: 2, sm: 0 }
          }}>
            <Button
              variant="contained"
              startIcon={<ExitToApp />}
              sx={{
                bgcolor: '#34495E',
                '&:hover': { bgcolor: '#2C3E50' }
              }}
              onClick={handleSignOutButton}
            >
              SIGN OUT
            </Button>
          </Box>
        </Box>

        <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
          <Tabs
            value={profileTabValue}
            onChange={handleTabChange}
            variant="fullWidth"
            sx={{
              '& .MuiTab-root': {
                textTransform: 'none',
                fontWeight: 'medium',
                fontSize: '0.9rem'
              },
              '& .Mui-selected': {
                color: '#2980B9',
                fontWeight: 'bold'
              },
              '& .MuiTabs-indicator': {
                backgroundColor: '#2980B9'
              }
            }}
          >
            <Tab label="Personal Details" />
            <Tab label="Contact Information" />
            <Tab label="Work Details" />
          </Tabs>
        </Box>

        <Box sx={{ p: 3 }}>
          {profileTabValue === 0 && (
            <Grid container spacing={3}>
              {renderEditableField("First Name", "first_name", updatedFields.first_name, <AccountCircle fontSize="small" color="action" sx={{ mr: 1 }} />)}
              {renderEditableField("Last Name", "last_name", updatedFields.last_name, <AccountCircle fontSize="small" color="action" sx={{ mr: 1 }} />)}
              {renderEditableField("Date of Birth", "date_of_birth", updatedFields.date_of_birth, <Cake fontSize="small" color="action" sx={{ mr: 1 }} />, "date")}
              {renderEditableField("Gender", "gender", updatedFields.gender, <Transgender fontSize="small" color="action" sx={{ mr: 1 }} />)}
              {renderEditableField("Blood Group", "blood_group", updatedFields.blood_group, <LocalHospital fontSize="small" color="action" sx={{ mr: 1 }} />)}
              {renderEditableField("Aadhar Number", "aadhar_number", updatedFields.aadhar_number, <Fingerprint fontSize="small" color="action" sx={{ mr: 1 }} />)}
            </Grid>
          )}

          {profileTabValue === 1 && (
            <Grid container spacing={3}>
              {renderNonEditableField("Work Email", email, <Email fontSize="small" color="action" sx={{ mr: 1 }} />)}
              {renderEditableField("Personal Email", "personal_email", updatedFields.personal_email, <Email fontSize="small" color="action" sx={{ mr: 1 }} />)}
              {renderEditableField("Phone Number", "phone_number", updatedFields.phone_number, <Phone fontSize="small" color="action" sx={{ mr: 1 }} />)}
              {renderEditableField("Emergency Contact", "emergency_contact", updatedFields.emergency_contact, <ContactEmergency fontSize="small" color="action" sx={{ mr: 1 }} />)}
              {renderEditableField("Emergency Contact Relationship", "emergency_contact_relationship", updatedFields.emergency_contact_relationship, <Person fontSize="small" color="action" sx={{ mr: 1 }} />)}
              
              <Grid item xs={12}>
                <Typography variant="subtitle2" fontWeight="bold" gutterBottom sx={{ display: 'flex', alignItems: 'center' }}>
                  <HomeWork fontSize="small" color="action" sx={{ mr: 1 }} />
                  Address
                </Typography>
                {isCurrentTabEditable() ? (
                  <TextField
                    fullWidth
                    variant="outlined"
                    size="small"
                    multiline
                    rows={3}
                    value={updatedFields.address}
                    placeholder="Enter your address"
                    onChange={(e) => handleInputChange('address', e.target.value)}
                  />
                ) : (
                  <Typography variant="body2" sx={{ ml: 3 }}>
                    {originalFields.address || 'Not specified'}
                  </Typography>
                )}
              </Grid>
            </Grid>
          )}

          {profileTabValue === 2 && (
            <Grid container spacing={3}>
              {renderNonEditableField("Department", department, <Business fontSize="small" color="action" sx={{ mr: 1 }} />)}
              {renderNonEditableField("Team", team, <Groups fontSize="small" color="action" sx={{ mr: 1 }} />)}
              {renderEditableField("Employee ID", "employee_id", updatedFields.emp_id, <BadgeIcon fontSize="small" color="action" sx={{ mr: 1 }} />)}
              {renderEditableField("Work Location", "work_location", updatedFields.work_location, <LocationOn fontSize="small" color="action" sx={{ mr: 1 }} />)}
              {/* {renderEditableField("Work Phone", "work_phone", updatedFields.work_phone, <Phone fontSize="small" color="action" sx={{ mr: 1 }} />)} */}
              {renderNonEditableField("Manager", `${managerName}${managerEmail ? ` (${managerEmail})` : ''}`, <Person fontSize="small" color="action" sx={{ mr: 1 }} />)}
              {renderNonEditableField("Role / Designation", `${userType || 'Not specified'}${designation ? ` - ${designation}` : ''}`, <Work fontSize="small" color="action" sx={{ mr: 1 }} />)}
              {renderNonEditableField("Organization", `${organizationName || 'Not specified'} `, <CorporateFare fontSize="small" color="action" sx={{ mr: 1 }} />)}
              {formattedJoinDate && renderNonEditableField("Date of Joining", formattedJoinDate, <CalendarToday fontSize="small" color="action" sx={{ mr: 1 }} />)}
            </Grid>
          )}
        </Box>
      </Box>

      {isCurrentTabEditable() && (
        <Box sx={{ display: 'flex', justifyContent: 'flex-end', p: 2, bgcolor: '#f5f5f5' }}>
          <Button
            variant="outlined"
            onClick={handleCancel}
            sx={{ mr: 2 }}
            disabled={isSubmitting}
          >
            CANCEL
          </Button>
          <Button
            variant="contained"
            color="primary"
            onClick={handleSaveChanges}
            disabled={isSubmitting}
          >
            {isSubmitting ? 'SAVING...' : 'SAVE CHANGES'}
          </Button>
        </Box>
      )}

      {updateSuccess && !isCurrentTabEditable() && (
        <Box sx={{ display: 'flex', justifyContent: 'center', p: 2, bgcolor: '#e8f5e9' }}>
          <Typography color="success.main" sx={{ display: 'flex', alignItems: 'center' }}>
            <CheckCircle fontSize="small" sx={{ mr: 1 }} />
            Profile updated successfully!
          </Typography>
        </Box>
      )}
      
      {/* {openTokenExpirePopup && (
        <Box sx={{ 
          display: 'flex', 
          justifyContent: 'center', 
          alignItems: 'center', 
          p: 2, 
          bgcolor: '#ffebee',
          borderRadius: 1
        }}>
          <Typography sx={{ mr: 2 }}>Your login session has expired. Please login again.</Typography>
          <Button 
            variant="contained"
            color="primary"
            onClick={() => navigate('/')}
          >
            Login
          </Button>
        </Box>
      )} */}
    </div>
  );
};

export default EditProfile;